import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=dbce73ae&scoped=true&"
var script = {}
import style0 from "./not-found.vue?vue&type=style&index=0&id=dbce73ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbce73ae",
  null
  
)

export default component.exports